var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(_setup.FormControlTypeCheckbox, {
    attrs: {
      "form-id": _vm.formId,
      field: _vm.field,
      "current-data": _vm.currentData,
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }